import { FC } from "react";
import { Checkbox, HStack, Text } from "@chakra-ui/react";

interface Props {
  onChange: () => void;
  isChecked: boolean;
  isError: boolean;
}

export const CHDPModalCheckbox: FC<Props> = ({ onChange, isChecked, isError }) => {
  return (
    <HStack spacing="8px" mx="12px" onClick={onChange} cursor="pointer" alignItems="flex-start">
      <Checkbox
        isChecked={isChecked}
        pointerEvents="none"
        isInvalid={isError}
      />

      <Text fontSize="14px" lineHeight="18px" mt="1px">
        Подтверждаю что,
        {" "}
        <Text as="span" variant="brand">платеж по графику внесу отдельно</Text>
      </Text>
    </HStack>
  );
};
